import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { FormProvider, useForm } from "react-hook-form";
import { childQuestions } from "../../data/child-questions";
import { FamilyFormState } from "../../models/FamilyFormState";
import { filterVisibleQuestions } from "../../services/question-filter";
import { Question } from "./Question";
import { CalculatorV2StepModel } from "../../models/calculator-configuration";
import { mapQuestionsConfig } from "../../mappers/question-config-mapper";
import { CalculatorTranslations } from "../../models/CalculatorTranslations";
import { Region } from "../../models/calculation-api.types";

export type AddChildModalProps = {
  initialState?: FamilyFormState;
  onAddChild: (child: FamilyFormState) => void;
  onClose: () => void;
  config: CalculatorV2StepModel;
  region: Region;
  translations: CalculatorTranslations;
};

export const AddChildModal = ({
  initialState,
  onAddChild,
  onClose,
  config,
  region,
  translations,
}: AddChildModalProps) => {
  const form = useForm<FamilyFormState>({
    defaultValues: initialState,
    mode: "onChange",
  });
  const { handleSubmit, watch, getValues } = form;

  const questions = mapQuestionsConfig(childQuestions, config);
  const visibleQuestions = filterVisibleQuestions(questions, watch(), region);

  const shouldBlock = questions.some(
    (q) => q.blocking && q.blocking(getValues())
  );

  const formEnabled = form.formState.isValid && !shouldBlock;

  const onSubmit = handleSubmit(function (data) {
    if (formEnabled) {
      console.debug("child data submitted", data);
      onAddChild(data);
    }
  });

  return (
    <Modal show={true} dialogClassName="dialog-tight">
      <FormProvider {...form}>
        <form onSubmit={onSubmit}>
          <fieldset>            
            <div className="d-flex px-4 py-2 text-white align-items-center bg-blue">
              <legend className="m-0">{translations.AddChild}</legend>
              <button type="button" className="btn btn-link p-0 ml-auto" onClick={onClose} aria-label="close">
                <img src="/img/svg/icon-x-transparent-white.svg" alt="" />
              </button>
            </div>

            <div className="container py-3">
              <div className="row">
                <div className="col-12 d-flex flex-column">
                  {visibleQuestions.map((question) => (
                    <Question
                      key={question.field}
                      question={question}
                      translations={translations}
                    />
                  ))}

                  <button type="submit" className={`btn btn-primary w-100 ${formEnabled ? "" : "disabled" }`} aria-label="add child">
                    {translations.AddChild}
                  </button>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </FormProvider>
    </Modal>
  );
};
